<template>
  <b-container v-if="createAny('users')" fluid>

    <!-- Title bar -->
    <div class="title-bar">
      <h1>{{ $t("titles.professions") }}</h1>
      <div @click="edit_profession({ id: 0 })" class="btn btn-primary">
        <font-awesome-icon icon="plus" /> {{ $t("buttons.addprofession") }}
      </div>
    </div>

    <!-- Table -->
    <b-table :items=professions :fields=fields @row-clicked="onprofessionClicked">
      <template #cell(actions)="row">
        <div class="action-items">
          <a href="javascript:;" class="btn" @click="delete_a_profession(row.item.id)" :title="$t('labels.deleteprofession')">
            <font-awesome-icon icon="trash" /> {{$t('labels.deleteprofession')}}
          </a>
        </div>
      </template>
    </b-table>

  </b-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import professions_details_modal from './modals/professionModal'
import popup_modal from './modals/PopupModal.vue'

export default {
  name: 'professionsscreen',
  data() {
    return {
      selectedID: null
    }
  },
  computed: {
    fields() {
      return [
        { key: 'profession', label: this.$i18n.t('labels.name'), sortable: true, sortDirection: 'desc' },
        { key: 'actions', label: this.$i18n.t('labels.actions') },
      ]
    },

    ...mapState([
      'professions',
    ]),
    ...mapGetters([
      'profession_by_id',
      'confirm_modal',
      'createAny'

    ]),
  },
  methods: {
    ...mapActions([
      'delete_profession',
      'save_profession'
    ]),
    delete_a_profession(id) {
      this.selectedID = id
      let message = this.$i18n.t('labels.confirmdeletehead') + this.profession_by_id(id).profession + this.$i18n.t('labels.confirmdeletetail')
      this.$modal.hide('popup_modal')
      this.$modal.show(popup_modal, {
        message: message,
      }, {
        name: 'popup_modal',
        draggable: false,
        height: 'auto',
        width: '500px'
      }, {
        'before-close': this.modalClose
      })

      this.$emit('close')

    },
    modalClose() {
      if (this.confirm_modal.id == 1) {
        this.delete_profession(this.selectedID);
        for (let i = 0; i < this.professions.length; i++) {
          if (this.professions[i].id == this.selectedID) {
            this.professions.splice(i, 1);
          }
        }
      }
    },
    onprofessionClicked(row) {
      this.$modal.hide('professions_details_modal')
      this.$modal.show(professions_details_modal, {
        profession_id: row.id,
      }, {
        name: 'professions_details_modal',
        draggable: '.popup-header',
        height: 'auto',
        width: '800px'
      })

      this.$emit('close')
    },
    edit_profession(profession) {
      this.$modal.hide('professions_details_modal')
      this.$modal.show(professions_details_modal, {
        profession_id: profession.id,
      }, {
        name: 'professions_details_modal',
        draggable: '.popup-header',
        height: 'auto',
        width: '800px'
      })

      this.$emit('close')
    },
  },
}
</script>